document.querySelectorAll('.btn.btn-primary').forEach(button => {
  button.addEventListener('click', function (e) {
    const oldRipple = this.querySelector('.ripple');
    if (oldRipple) oldRipple.remove();

    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const ripple = document.createElement('span');
    ripple.classList.add('ripple');
    ripple.style.width = ripple.style.height = `${Math.max(rect.width, rect.height)}px`;
    ripple.style.left = `${x - rect.width / 2}px`;
    ripple.style.top = `${y - rect.height / 2}px`;

    this.appendChild(ripple);

    ripple.addEventListener('animationend', () => ripple.remove());
  });
});
